import React from 'react';

import { withFlavour } from '@xingternal/flavour';
import { Grid, Row, Column } from '@xingternal/malt-grid';

import Fallback from '@xingternal/fallback';

import GdprImage from './../Illustrations/GdprImage';
import Spacer from './../Spacer/Spacer';

const GridWrapper = React.memo(({ wide = false, children, flavour }) => (
  <Grid outermost>
    <Row outermost>
      <Column
        size={12}
        offset={0}
        sizeTablet={8}
        offsetTablet={2}
        sizeDesktop={wide ? 12 : 4}
        offsetDesktop={wide ? 0 : 4}
      >
        <Fallback>
          <span>{flavour === 'xdl' && <Spacer size={6} />}</span>
          {children}
          <GdprImage />
          <Spacer size={32} media={'tablet'} />
        </Fallback>
      </Column>
    </Row>
  </Grid>
));

export default withFlavour(GridWrapper);
